import {createSlice} from "@reduxjs/toolkit"

const CompanyLevelRateLimitSlice = createSlice({
    name: "companyLevelRateLimit",
    initialState: {
        companyName: "",
        companyId: "",
        companyType: "",
        rateLimitType: {
            loc_put_per_min: "",
            company_loc_put_per_min: "",
            evse_patch_per_min: "",
            loc_get_per_min: "",
        },
    },
    reducers: {
        redirectCompanyLevelRateLimit: (state, action) => {
            state.companyId = action.payload.companyId
            state.companyName = action.payload.companyName
            state.companyType = action.payload.companyType
            state.rateLimitType = action.payload.rateLimitType
        },
    },
})

export const {redirectCompanyLevelRateLimit} = CompanyLevelRateLimitSlice.actions
export default CompanyLevelRateLimitSlice.reducer
